import type { ToastModel } from '$lib_commons/models/toast-model.ts'
import { writable, type Writable } from 'svelte/store'

export const toastsStore: Writable<ToastModel[]> = writable([])
